import React from "react";
import { SubscribeCardProps } from "./SubscribeCard";
import NewCard from "./SubscribeCard/NewCard";
import { STIPE_PACKAGE_IDS } from "../../Stripe/constants";
import { TEST_STRIPE } from "@/src/constants";

export interface SubscribeCardsProps {
  activeSubscriptionProductIds: string[];
}

export const mockCards: SubscribeCardProps[] = [
  {
    title: "SCPB Premium",
    price: "$50",
    yearlyPrice: "$50",
    yearlyExpiry: "2025",
    highlight: "The Full SCPB package",
    desc: [
      `<b>2024 NRL</b> Supercoach season`,
      `<b>2024/2025 BBL</b> Supercoach season`,
      "<b>Year round exclusive content",
      `<b>Whatsapp</b> group access`,
      "<b>Premium articles and insght</b>",
    ],

    link: "http://google.com",
    imageURL:
      "https://scplaybook.com.au/wp-content/uploads/2023/08/draft-1.jpg",
    hero: true,
    index: 2,
    packageId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["FULL"].productId,
    priceId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["FULL"].price,
    subProducts: [
      {
        id: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["FULL"].oneOffId,
        type: "oneoff",
        price: "50",
        description: "2024 Season",
        priceId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["FULL"].oneOffPrice,
      },
    ],
  },
  {
    title: "NRL",
    highlight: "NRL content package",
    price: "$30",
    yearlyPrice: "$30",
    yearlyExpiry: "2025",
    desc: [
      `<b>2024 NRL</b> Supercoach season`,
      "<b>Whatsapp and exclusive content</b>",
      "<b>Premium articles and insght</b>",
    ],
    link: "http://google.com",
    hero: false,
    index: 1,
    imageURL:
      "https://scplaybook.com.au/wp-content/uploads/2022/01/Boom-or-bust.png",
    packageId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["NRL"].productId,
    priceId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["NRL"].price,
    subProducts: [
      {
        id: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["NRL"].oneOffId,
        type: "oneoff",
        price: "30",
        description: "2024 Season",
        priceId: STIPE_PACKAGE_IDS[TEST_STRIPE]["packages"]["NRL"].oneOffPrice,
      },
    ],
  },
];

const SubScribeCards = ({
  activeSubscriptionProductIds = [],
}: SubscribeCardsProps) => {
  return (
    <div
      className={
        "flex flex-row gap-4 items-center align-center justify-center mx-2 w-full"
      }
    >
      <div className={"subcard-container container grid gap-4"}>
        {mockCards.map(function (card, index) {
          return (
            <NewCard
              {...card}
              key={`subcard-${index}`}
              isSubscribed={activeSubscriptionProductIds.includes(
                card.packageId
              )}
              activeSubs={activeSubscriptionProductIds}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SubScribeCards;
